module.exports = __webpack_public_path__ + "static/media/wings.3d6125b1.jpg";